import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';

export default function SpacerNew({ blok }) {
  return (
    <div {...storyblokEditable(blok)} className={`${blok.desktopspacing} ${blok.mobilespacing} ${blok.custom_classes}`} />
  );
}
